'use client';

import PartnerLoginForm from './PartnerLoginForm';
import Link from 'next/link';
import styles from './partnerLoginContent.module.scss';
import { usePartnerAccountRedirect } from '@/hooks/usePartnerAccountRedirect';

export default function PartnerLoginContent() {
  usePartnerAccountRedirect();

  return (
    <main className={styles.main}>
      <div className={styles.header}>
        <h1 className={styles.title}>Welcome back</h1>
        <p className={styles.subtitle}>Let&apos;s keep doing Good, together.</p>
      </div>
      <PartnerLoginForm />
      <div className={styles.footer}>
        Don&apos;t have an account?{' '}
        <Link href="/partner/sign-up" className={styles.signupLink}>
          Sign up
        </Link>
      </div>
    </main>
  );
}
